import WorkspaceAddForm from 'components/feature/workspace/add/WorkspaceAddForm';

const WorkspaceAddPage = () => {
  return <WorkspaceAddForm />;
};
export default WorkspaceAddPage;
